module.exports = __webpack_public_path__ + "static/media/hospitalUnit.7812175d.png";